import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API } from "../constants/config";

const GD = "#8B6914";
const GDL = "#A07828";

function VajraHeader({ member, onLogout, navigate }) {
  return (
    <div style={{
      position: "sticky", top: 0, zIndex: 100,
      background: "rgba(253,251,247,0.92)", backdropFilter: "blur(16px)",
      borderBottom: "1px solid rgba(212,175,55,0.25)",
      padding: "0 24px", height: 56, display: "flex", alignItems: "center", justifyContent: "space-between",
    }}>
      <button onClick={() => navigate("/vajra")} style={{
        display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", cursor: "pointer", padding: 0,
      }}>
        <span style={{ color: GD, fontSize: 18 }}>☸</span>
        <div>
          <div style={{ color: GD, fontSize: 14, letterSpacing: 3 }}>如意宝金刚社群</div>
          <div style={{ color: "#6B4C3B", fontSize: 9, letterSpacing: 2, opacity: 0.8 }}>BTF CANADA</div>
        </div>
      </button>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {member ? (
          <>
            <span style={{ fontSize: 12, color: "#6B4C3B" }}>{member.dharma_name || member.name}</span>
            <button onClick={onLogout}
              style={{ background: "none", border: "none", color: "#6B4C3B", fontSize: 11, cursor: "pointer", textDecoration: "underline", padding: 0 }}>
              退出
            </button>
          </>
        ) : (
          <button onClick={() => navigate("/vajra")} style={{
            background: `linear-gradient(135deg,${GD},${GDL})`, border: "none", borderRadius: 8,
            color: "#fff", fontSize: 12, padding: "7px 20px", cursor: "pointer", letterSpacing: 1,
          }}>
            登录 / 注册
          </button>
        )}
      </div>
    </div>
  );
}

function GallerySection({ images }) {
  if (!images || !Array.isArray(images) || images.length === 0) return null;
  return (
    <div style={{ marginTop: 32 }}>
      <h3 style={{ fontSize: 15, fontWeight: 600, color: "#064E3B", marginBottom: 14 }}>
        📸 活动照片
      </h3>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
        gap: 10,
      }}>
        {images.map((url, i) => (
          <img key={i} src={url} alt={`活动照片 ${i + 1}`}
            style={{
              width: "100%",
              borderRadius: 8,
              objectFit: "cover",
              aspectRatio: "4/3",
              border: "1px solid rgba(0,0,0,0.06)",
              cursor: "pointer",
            }}
            onClick={() => window.open(url, "_blank")}
          />
        ))}
      </div>
    </div>
  );
}


export default function EventDetailPage({ lang = "zh", setPage }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [member, setMember] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("vajra_token");
    if (token) {
      fetch(`${API}/vajra/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then(r => r.ok ? r.json() : null)
        .then(d => { if (d) setMember(d); })
        .catch(() => {});
    }
  }, []);

  const handleLogout = () => { localStorage.removeItem("vajra_token"); setMember(null); };

  useEffect(() => {
    // Don't call setPage("events") — it redirects to /events, losing the slug
    fetch(`${API}/vajra/events/${slug}`)
      .then(r => { if (!r.ok) { setNotFound(true); setLoading(false); return null; } return r.json(); })
      .then(data => { if (data) { setEvent(data); setLoading(false); } })
      .catch(() => { setNotFound(true); setLoading(false); });
  }, [slug]);

  if (loading) return (
    <div style={{ minHeight: "100vh", background: "#FDFBF7" }}>
      <VajraHeader member={member} onLogout={handleLogout} navigate={navigate} />
      <div style={{ textAlign: "center", paddingTop: 100, color: "#9ca3af" }}>加载中…</div>
    </div>
  );

  if (notFound || !event) return (
    <div style={{ minHeight: "100vh", background: "#FDFBF7" }}>
      <VajraHeader member={member} onLogout={handleLogout} navigate={navigate} />
      <div style={{ textAlign: "center", paddingTop: 100 }}>
      <div style={{ fontSize: 32, marginBottom: 12 }}>☸</div>
      <div style={{ color: "#6b7280" }}>活动不存在或已下线</div>
      <button onClick={() => navigate(-1)} style={{ marginTop: 20, padding: "8px 20px", borderRadius: 8, border: "1px solid #064E3B", background: "transparent", color: "#064E3B", cursor: "pointer" }}>
        活动列表
      </button>
    </div>
    </div>
  );

  if (event.event_type === "retreat") {
    return (
      <div style={{ minHeight: "100vh", background: "#FDFBF7" }}>
        <VajraHeader member={member} onLogout={handleLogout} navigate={navigate} />
        <RetreatDetailView event={event} lang={lang} navigate={navigate} member={member} />
      </div>
    );
  }

  if (event.is_external) {
    return (
      <div style={{ minHeight: "100vh", background: "#FDFBF7" }}>
        <VajraHeader member={member} onLogout={handleLogout} navigate={navigate} />
        <ExternalEventView event={event} lang={lang} navigate={navigate} />
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", background: "#FDFBF7" }}>
      <VajraHeader member={member} onLogout={handleLogout} navigate={navigate} />
      <StandardEventView event={event} lang={lang} navigate={navigate} />
    </div>
  );
}


function RetreatDetailView({ event, lang, navigate }) {
  const [form, setForm] = useState({ name: "", email: "", phone: "", wechat: "", has_empowerment: false, notes: "" });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const reqs = parseJsonList(event.requirements);
  let sessions = event.sessions;
  if (typeof sessions === 'string') { try { sessions = JSON.parse(sessions); } catch(e) { sessions = []; } }
  if (!Array.isArray(sessions)) sessions = [];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.email.trim()) { setError("姓名与邮箱必填"); return; }
    setSubmitting(true); setError("");
    try {
      const r = await fetch(`${API}/vajra/events/${event.id}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await r.json();
      if (r.ok) { setSubmitted(true); }
      else { setError(data.detail || "报名失败，请稍后再试"); }
    } catch { setError("网络错误，请稍后再试"); }
    setSubmitting(false);
  };

  return (
    <div style={{ maxWidth: 760, margin: "0 auto", padding: "0 20px 60px" }}>
      {event.cover_image_url && (
        <div style={{ width: "100%", maxHeight: 360, overflow: "hidden", borderRadius: "0 0 16px 16px" }}>
          <img src={event.cover_image_url} alt={lang === 'en' && event.title_en ? event.title_en : event.title_zh} style={{ width: "100%", objectFit: "cover" }} />
        </div>
      )}
      <div style={{ padding: event.cover_image_url ? "32px 0 0" : "40px 0 0" }}>
        <button onClick={() => navigate(-1)} style={{ fontSize: 12, color: "#6b7280", background: "none", border: "none", cursor: "pointer", marginBottom: 16, padding: 0 }}>
          ← 返回
        </button>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: "#064E3B", marginBottom: 6 }}>{lang === 'en' && event.title_en ? event.title_en : event.title_zh}</h1>
        {event.subtitle_zh && <div style={{ fontSize: 15, color: "#6b7280", marginBottom: 16 }}>{lang === 'en' && event.subtitle_en ? event.subtitle_en : event.subtitle_zh}</div>}

        <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 24, fontSize: 14, color: "#374151" }}>
          {event.teacher_zh && <span>🪷 {lang === 'en' && event.teacher_en ? event.teacher_en : event.teacher_zh}</span>}
          {event.start_date && <span>📅 {event.start_date}{event.end_date ? ` ~ ${event.end_date}` : ""}</span>}
          {event.location && <span>📍 {event.location}</span>}
          {event.capacity && <span>👥 名额：{event.capacity}</span>}
        </div>

        {(()=>{const desc=lang==='en'?(event.description_en||event.description_zh):(event.description_zh||event.description_en);if(!desc)return null;return <div style={{fontSize:15,color:"#4b5563",fontStyle:"italic",marginBottom:20,padding:"12px 16px",background:"rgba(6,78,59,0.04)",borderLeft:"3px solid #064E3B",borderRadius:"0 8px 8px 0",lineHeight:1.8}}>{desc}</div>;})()}

        {/* Sessions schedule — v2 */}
        {sessions.length > 0 && (
        <div style={{marginBottom:24}}>
          <h3 style={{fontSize:15,fontWeight:600,color:"#064E3B",marginBottom:10}}>📅 课程安排 / Schedule</h3>
          <div style={{display:"grid",gap:6}}>
            {sessions.map((s,i)=>(
            <div key={i} style={{padding:"10px 14px",background:"rgba(6,78,59,0.03)",borderRadius:8,border:"1px solid rgba(6,78,59,0.08)",
              display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <span style={{fontSize:13,color:"#064E3B",fontWeight:600}}>{s.date}</span>
                <span style={{fontSize:13,color:"#374151",marginLeft:12}}>{s.title_zh||s.title_en||""}</span>
                {s.title_en&&s.title_zh&&<span style={{fontSize:11,color:"#9ca3af",marginLeft:8}}>({s.title_en})</span>}
              </div>
              {s.time&&<span style={{fontSize:12,color:"#6b7280"}}>{s.time}</span>}
            </div>
            ))}
          </div>
        </div>
        )}

        {/* Bilingual flyers */}
        {(event.flyer_zh || event.flyer_en) && (
          <div style={{ marginBottom: 24, display: "grid", gridTemplateColumns: event.flyer_zh && event.flyer_en ? "1fr 1fr" : "1fr", gap: 16 }}>
            {event.flyer_zh && (
              <div>
                <div style={{ fontSize: 11, color: "#6b7280", letterSpacing: 2, marginBottom: 8, textAlign: "center" }}>中文海报</div>
                <img src={event.flyer_zh} alt="中文海报" style={{ width: "100%", borderRadius: 8, border: "1px solid rgba(0,0,0,0.08)" }} />
              </div>
            )}
            {event.flyer_en && (
              <div>
                <div style={{ fontSize: 11, color: "#6b7280", letterSpacing: 2, marginBottom: 8, textAlign: "center" }}>English Flyer</div>
                <img src={event.flyer_en} alt="English flyer" style={{ width: "100%", borderRadius: 8, border: "1px solid rgba(0,0,0,0.08)" }} />
              </div>
            )}
          </div>
        )}

        {reqs.length > 0 && (
          <div style={{ marginBottom: 24 }}>
            <h3 style={{ fontSize: 15, fontWeight: 600, color: "#064E3B", marginBottom: 10 }}>参加须知</h3>
            <ul style={{ paddingLeft: 20, lineHeight: 1.9 }}>
              {reqs.map((r, i) => <li key={i} style={{ fontSize: 14, color: "#4b5563" }}>{r}</li>)}
            </ul>
          </div>
        )}

        {event.fee_note && (
          <div style={{ padding: "12px 16px", background: "rgba(212,175,55,0.08)", border: "1px solid rgba(212,175,55,0.2)", borderRadius: 8, marginBottom: 24, fontSize: 13, color: "#6b4c00" }}>
            💰 {event.fee_note}
          </div>
        )}

        <div style={{ background: "#f9fafb", borderRadius: 12, padding: 24, border: "1px solid rgba(6,78,59,0.1)" }}>
          <h2 style={{ fontSize: 18, fontWeight: 600, color: "#064E3B", marginBottom: 20 }}>
            {submitted ? "✅ 报名成功" : "报名"}
          </h2>
          {submitted ? (
            <div style={{ color: "#374151", lineHeight: 1.8 }}>
              感恩您的报名！我们会尽快与您联系确认详情。<br/>
              如有疑问请联系如意宝群管理员。🙏
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              {error && <div style={{ background: "rgba(220,38,38,0.06)", color: "#dc2626", padding: "8px 12px", borderRadius: 6, fontSize: 13, marginBottom: 14 }}>{error}</div>}
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                <Field label="姓名 *" value={form.name} onChange={v => setForm({ ...form, name: v })} placeholder="法名或俗名" />
                <Field label="邮箱 *" value={form.email} onChange={v => setForm({ ...form, email: v })} placeholder="your@email.com" type="email" />
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
                <Field label="电话（选填）" value={form.phone} onChange={v => setForm({ ...form, phone: v })} placeholder="+1 (416) ..." />
                <Field label="微信号（选填）" value={form.wechat} onChange={v => setForm({ ...form, wechat: v })} placeholder="WeChat ID" />
              </div>
              <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#374151", marginBottom: 14, cursor: "pointer" }}>
                <input type="checkbox" checked={form.has_empowerment} onChange={e => setForm({ ...form, has_empowerment: e.target.checked })} />
                已获得相关灌顶传承
              </label>
              <div style={{ marginBottom: 16 }}>
                <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>备注（选填）</label>
                <textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })}
                  placeholder="修行背景 / 特殊需求" rows={3}
                  style={{ width: "100%", padding: "8px 10px", border: "1px solid rgba(0,0,0,0.12)", borderRadius: 7, fontSize: 13, resize: "vertical", boxSizing: "border-box" }} />
              </div>
              <button type="submit" disabled={submitting}
                style={{ padding: "10px 28px", background: submitting ? "#9ca3af" : "#064E3B", color: "#fff", border: "none", borderRadius: 8, fontSize: 14, cursor: submitting ? "not-allowed" : "pointer", fontWeight: 600 }}>
                {submitting ? "提交中…" : "提交报名"}
              </button>
            </form>
          )}
        </div>
        <GallerySection images={event.gallery_images} />
      </div>
    </div>
  );
}


function ExternalEventView({ event, lang, navigate }) {
  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: "40px 20px" }}>
      <button onClick={() => navigate(-1)} style={{ fontSize: 12, color: "#6b7280", background: "none", border: "none", cursor: "pointer", marginBottom: 16, padding: 0 }}>
        ← 返回
      </button>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: "#1a1a1a", marginBottom: 6 }}>{lang === 'en' && event.title_en ? event.title_en : event.title_zh}</h1>
      {event.subtitle_zh && <div style={{ fontSize: 14, color: "#6b7280", marginBottom: 16 }}>{lang === 'en' && event.subtitle_en ? event.subtitle_en : event.subtitle_zh}</div>}
      <div style={{ display: "inline-block", padding: "3px 10px", background: "rgba(107,114,128,0.1)", borderRadius: 10, fontSize: 12, color: "#6b7280", marginBottom: 20 }}>
        外部活动
      </div>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 20, fontSize: 14, color: "#374151" }}>
        {event.teacher_zh && <span>🪷 {lang === 'en' && event.teacher_en ? event.teacher_en : event.teacher_zh}</span>}
        {event.start_date && <span>📅 {event.start_date}</span>}
        {event.location && <span>📍 {event.location}</span>}
      </div>
      {(()=>{const desc=lang==='en'?(event.description_en||event.description_zh):(event.description_zh||event.description_en);if(!desc)return null;return <p style={{fontSize:15,color:"#4b5563",lineHeight:1.8}}>{desc}</p>;})()}
      <div style={{ marginTop: 24, padding: "12px 16px", background: "rgba(107,114,128,0.05)", borderRadius: 8, fontSize: 13, color: "#6b7280" }}>
        此为外部活动，如需报名请联系主办方。
      </div>
      <GallerySection images={event.gallery_images} />
    </div>
  );
}


function StandardEventView({ event, lang, navigate }) {
  const reqs = parseJsonList(event.requirements);
  let sessions = event.sessions;
  if (typeof sessions === 'string') { try { sessions = JSON.parse(sessions); } catch(e) { sessions = []; } }
  if (!Array.isArray(sessions)) sessions = [];
  return (
    <div style={{ maxWidth: 700, margin: "0 auto", padding: "40px 20px" }}>
      <button onClick={() => navigate(-1)} style={{ fontSize: 12, color: "#6b7280", background: "none", border: "none", cursor: "pointer", marginBottom: 16, padding: 0 }}>
        ← 返回
      </button>
      {event.cover_image_url && (
        <img src={event.cover_image_url} alt={lang === 'en' && event.title_en ? event.title_en : event.title_zh}
          style={{ width: "100%", borderRadius: 12, marginBottom: 20, maxHeight: 300, objectFit: "cover" }} />
      )}
      <h1 style={{ fontSize: 24, fontWeight: 700, color: "#1a1a1a", marginBottom: 6 }}>{lang === 'en' && event.title_en ? event.title_en : event.title_zh}</h1>
      {event.subtitle_zh && <div style={{ fontSize: 14, color: "#6b7280", marginBottom: 16 }}>{lang === 'en' && event.subtitle_en ? event.subtitle_en : event.subtitle_zh}</div>}
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap", marginBottom: 20, fontSize: 14, color: "#374151" }}>
        {event.teacher_zh && <span>🪷 {lang === 'en' && event.teacher_en ? event.teacher_en : event.teacher_zh}</span>}
        {event.start_date && <span>📅 {event.start_date}{event.end_date ? ` ~ ${event.end_date}` : ""}</span>}
        {event.location && <span>📍 {event.location}</span>}
      </div>
      {(()=>{const desc=lang==='en'?(event.description_en||event.description_zh):(event.description_zh||event.description_en);if(!desc)return null;return <p style={{fontSize:15,color:"#4b5563",lineHeight:1.8,marginBottom:16}}>{desc}</p>;})()}
      {/* Sessions schedule */}
      {sessions.length > 0 && (
        <div style={{ marginBottom: 24, marginTop: 8 }}>
          <h3 style={{ fontSize: 16, fontWeight: 600, color: "#1a1a1a", marginBottom: 12 }}>📅 课程安排 / Schedule</h3>
          <div style={{ display: "grid", gap: 8 }}>
            {sessions.map((s, i) => (
            <div key={i} style={{ padding: "10px 14px", background: "rgba(6,78,59,0.03)", borderRadius: 8, border: "1px solid rgba(6,78,59,0.08)",
              display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <span style={{ fontSize: 13, color: "#064E3B", fontWeight: 600 }}>{s.date}</span>
                <span style={{ fontSize: 13, color: "#374151", marginLeft: 12 }}>{s.title_zh || s.title_en || ""}</span>
                {s.title_en && s.title_zh && <span style={{ fontSize: 11, color: "#9ca3af", marginLeft: 8 }}>({s.title_en})</span>}
              </div>
              {s.time && <span style={{ fontSize: 12, color: "#6b7280" }}>{s.time}</span>}
            </div>
            ))}
          </div>
        </div>
      )}
      {/* Requirements */}
      {reqs.length > 0 && (
        <div style={{ marginBottom: 24, padding: "14px 18px", background: "rgba(220,38,38,0.04)", borderRadius: 8, border: "1px solid rgba(220,38,38,0.15)" }}>
          <h3 style={{ fontSize: 14, fontWeight: 600, color: "#dc2626", marginBottom: 10 }}>⚠️ 参加须知 / Requirements</h3>
          <ul style={{ paddingLeft: 20, lineHeight: 1.9, margin: 0 }}>
            {reqs.map((r, i) => <li key={i} style={{ fontSize: 14, color: "#4b5563" }}>{r}</li>)}
          </ul>
        </div>
      )}
      {event.online_link && (
        <div style={{ padding: "10px 14px", background: "rgba(99,102,241,0.06)", border: "1px solid rgba(99,102,241,0.15)", borderRadius: 8, marginBottom: 16, fontSize: 13, color: "#374151" }}>
          💻 {event.online_link}
        </div>
      )}
      {event.fee_note && (
        <div style={{ padding: "10px 14px", background: "rgba(212,175,55,0.08)", border: "1px solid rgba(212,175,55,0.2)", borderRadius: 8, fontSize: 13, color: "#6b4c00", marginBottom: 16 }}>
          💰 {event.fee_note}
        </div>
      )}
      <GallerySection images={event.gallery_images} />
    </div>
  );
}


function Field({ label, value, onChange, placeholder, type = "text" }) {
  return (
    <div>
      <label style={{ fontSize: 12, color: "#6b7280", display: "block", marginBottom: 4 }}>{label}</label>
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        style={{ width: "100%", padding: "8px 10px", border: "1px solid rgba(0,0,0,0.12)", borderRadius: 7, fontSize: 13, boxSizing: "border-box" }} />
    </div>
  );
}


function parseJsonList(str) {
  if (!str) return [];
  try {
    const v = JSON.parse(str);
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
}
